import { getUnix } from "@common/utils/Time";
import jwt_decode from "jwt-decode";
export var Auth;
(function (Auth) {
    const KEY_JWT_TOKEN = "JWT_TOKEN";
    function setJwtToken(token) {
        localStorage.setItem(KEY_JWT_TOKEN, token);
    }
    Auth.setJwtToken = setJwtToken;
    function getJwtToken() {
        return localStorage.getItem(KEY_JWT_TOKEN);
    }
    Auth.getJwtToken = getJwtToken;
    function isValidJwtToken(token) {
        if (token == null || token == "")
            return false;
        try {
            const decoded = jwt_decode(token);
            return getUnix() < decoded.exp;
        }
        catch {
            return false;
        }
    }
    Auth.isValidJwtToken = isValidJwtToken;
    function getEmail(token) {
        if (token == null)
            return null;
        try {
            const decoded = jwt_decode(token);
            if (decoded.email == undefined)
                return null;
            return decoded.email;
        }
        catch {
            return null;
        }
    }
    Auth.getEmail = getEmail;
    function getUserId(token) {
        if (token == null)
            return null;
        try {
            const decoded = jwt_decode(token);
            if (decoded.userId == undefined)
                return null;
            return decoded.userId;
        }
        catch {
            return null;
        }
    }
    Auth.getUserId = getUserId;
    function isSubscriptionActive(token) {
        if (token == null || token == "")
            return false;
        try {
            const decoded = jwt_decode(token);
            if (decoded.subExp == null || decoded.subExp == undefined)
                return false;
            return getUnix() < decoded.subExp;
        }
        catch {
            return false;
        }
    }
    Auth.isSubscriptionActive = isSubscriptionActive;
})(Auth || (Auth = {}));
